import { nanoid } from 'nanoid';

// HEAD DATA
export const headData = {
  title: 'Damodar Subedi', // e.g: 'Name | Developer'
  lang: 'en', // e.g: en, es, fr, jp
  description: 'Welcome to my website ', // e.g: Welcome to my website
};

//NavBAr Logo
export const navLogo={
  img:'mylogo.png'
}

// HERO DATA
export const heroData = {
  title: '',
  name: 'Damodar Subedi',
  subtitle: ' Web and Mobile Application Developer',
  cta: '',
};

// ABOUT DATA
export const aboutData = {
  img: 'dp1.jpg',
  name:" Damodar Subedi",
  address:" Kathmandu, Nepal",
  paragraphOne: ' To achieve success in this growing technology with the motive of bringing excellence in personal skills and organizational goals. ',
  paragraphTwo: ' C#, Java, HTML, JS, CSS, Dart, Python and can adapt in different object oriented programming language easily',
  paragraphThree: ' Flutter, Asp.Net, Laravel, NodeJS, Strapi, NodeJS, Dialogflow',
  resume: 'https://www.resumemaker.online/es.php', // if no reume use this site to create if yes place it in images inside scr
};

// PROJECTS DATA
export const projectsData = [
  {
    id: nanoid(),
    img: 'Quiz.png',
    title: 'Quiz App',
    info: 'This application is created by using flutter with dio BLOC pattern and provider. This application is all about playing the quiz and getting the reward on leading the leaderboard. This application is a company based worked in which I have developed the application using the flutter as per the given API provided by the backend developer. The design in this application are given by the UI designer and got hundred percent success in making the design. The backend and frontend is handle by using RxDart, Dio and Bloc pattern. ',
    info2: '',
    url: '',
    repo: '', // if no repo, the button will not show up
  },
  {
    id: nanoid(),
    img: 'Policy.png',
    title: 'Insurance Policy Suggest App',
    info: 'This is the project of a company where I had performed and mobile application development of policy suggestion application. In this application normal user can search about the policy and plans offered by different insurance companies as per the enquiry provided by the user. The task that I had performed was to create the android application based on the API provided from the backend. In this project I had used RxDart Bloc pattern and Dio for fetching and maintaining different HTTP request to API. ',
    info2: '',
    url: '',
    repo: '', // if no repo, the button will not show up
  },
  {
    id: nanoid(),
    img: 'Furnico.png',
    title: 'UI Design of  Ecommerce Furnico App',
    info: 'This project is done in a team of a company where my duty was to complete the UI for the eccomerce furniture selling app. ',
    info2: '',
    url: '',
    repo: '', // if no repo, the button will not show up
  },
  {
    id: nanoid(),
    img: 'MediLoc.png',
    title: 'MediLoc: Pharmacy locator app by searching medicine',
    info: 'This is one of the biggest project done by me so far where the backend is created by using Node JS and mongoDB and frontend is created by using Flutter. In this application the user can search any medicine and get the details and location of the pharmacy (registered in app) nearby. Then he can communicate with that pharmacy too. The pharmacy who have registered in the application also can manage their product. A Chabot that suggest the homemade remedy is also being integrated. Rather than that an admin control system is also being made using EJS.',
    info2: '',
    url: '',
    repo: '', // if no repo, the button will not show up
  },
  {
    id: nanoid(),
    img: 'billing.png',
    title: 'Python Billing System ',
    info: 'It was python console based project which comes under my curriculum. In this project first system gives customer list of product. Then customer chooses one after that customer prices for quantity discounts are calculated and an invoice is generated as text file.',
    info2: '',
    repo: 'https://github.com/damodarsubedi/pythonBilling', // if no repo, the button will not show up
  },
  {
    id: nanoid(),
    img: 'Netbeans.png',
    title: 'JAVA Based CRUD with Search  ',
    info: 'This project was created in Netbeans. In normal we have user input UI created with java swing where we can add data which gets inserted in the table which is also in system. We can manipulate like edit and delete the data from table. It also have search panel to search product from table. We can also add data through text file in the table too.',
    info2: '',
    url: '',
    repo: 'https://github.com/damodarsubedi/neatbeans', // if no repo, the button will not show up
  },
  {
    id: nanoid(),
    img: 'first.png',
    title: 'Theme changing Flutter UI',
    info: 'In this project there is different screens that are being made using Flutter like by using the widgets cards, changing normal theme and dart theme in an application. ',
    info2: '',
    url: '',
    repo: 'https://github.com/damodarsubedi/flutterFirstProject', // if no repo, the button will not show up
  },
  {
    id: nanoid(),
    img: 'Chatbot.png',
    title: 'Chatbot integration to Facebook Page',
    info: 'In this I have created a chatbot using Google dailogflow. The created chatbot is integrated into Facebook page and the application for it was created using Facebook Book Developers React',
    info2: '',
    url: '',
    repo: '', // if no repo, the button will not show up
  },
  
  {
    id: nanoid(),
    img: 'Dvd.png',
    title: 'Music Rental App with Asp.Net',
    info: 'Created an Asp.net Core website using SQL server and entity framework. The app the different albums of different artist is placed to be rent for any other customer. This application tracks the record of number sold unsold copies of Album also tacks the record of the customers rental details.',
    info2: '',
    url: '',
    repo: 'https://github.com/damodarsubedi/musicRental', // if no repo, the button will not show up
  },
  
  
  
  {
    id: nanoid(),
    img: 'Beer.png',
    title: 'Beer bootle Game (Netbeans)',
    info: 'This is an game that is build in both CLI and GUI. In this game there are 21 bottles where the game is played between user and program. In one round only 4 bottles can be chhosen as if user choose 1 computer must choose number less or equals to 3 ',
    info2: '',
    url: '',
    repo: 'https://github.com/damodarsubedi/beer-bottle-game', // if no repo, the button will not show up
  },
  {
    id: nanoid(),
    img: 'Ghumfir.png',
    title: 'Hotel Room Reservation with NodeJS',
    info: 'This system is built as website using nodeJs and firebase, templeting system EJS and firebase database. A hotel first registers their details and room. Then any user using app can book the hotel room by selecting the hotel from the map which is also being integrated in the system.  ',
    info2: '',
    url: '',
    repo: 'https://github.com/damodarsubedi/hotelRental', // if no repo, the button will not show up
  }
];

// CONTACT DATA
export const contactData = {
  cta: '',
  btn: 'Mail Me',
  email: 'damodarsubedi2015@gmail.com',
};

// FOOTER DATA
export const footerData = {
  networks: [
    {
      id: nanoid(),
      name: 'twitter',
      url: 'https://twitter.com/damodarsubedi4',
    },
    {
      id: nanoid(),
      name: 'facebook',
      url: 'https://www.facebook.com/viperdamodar',
    },
    {
      id: nanoid(),
      name: 'linkedin',
      url: 'https://www.linkedin.com/in/damodar-subedi-6ba88a191/',
    },
    {
      id: nanoid(),
      name: 'github',
      url: 'https://github.com/damodarsubedi',
    },,
    {
      id: nanoid(),
      name: 'instagram',
      url: 'https://www.instagram.com/viperdamodar/',
    },
  ],
};

// Github start/fork buttons
export const githubButtons = {
  isEnabled: true, // set to false to disable the GitHub stars/fork buttons
};
